import {Mesh, BoxGeometry, MeshBasicMaterial, TextureLoader} from "three";
import {mergeBufferGeometries} from "three/examples/jsm/utils/BufferGeometryUtils";
const createServer = (width,height,depth) => {
    //两层的服务器
    const serverGeo = new BoxGeometry(width,height,depth); //这里服务器的尺寸要跟机箱尺寸对应好
    const servMat = new MeshBasicMaterial({
        color: 0x86a6cb,
    });
    const serverBox = new Mesh(serverGeo, servMat); //服务器主体
    serverBox.position.set(0,0,0)

    const serverFaceGeo = new BoxGeometry(width, height + 0.5, 0.2); //服务器面板尺寸
    const serverFaceMaterial = new MeshBasicMaterial({
        map: new TextureLoader().load('/three/server-room/server2.jpg'),
    });
    const serverFace = new Mesh(serverFaceGeo, serverFaceMaterial);
    serverFace.position.set(0, 0, depth / 2 + 0.1);

    serverBox.updateMatrix();
    serverFace.updateMatrix();
    serverBox.geometry.applyMatrix4(serverBox.matrix);
    serverFace.geometry.applyMatrix4(serverFace.matrix);

    const mergedGeometry = mergeBufferGeometries([serverBox.geometry,serverFace.geometry],true)
    const server = new Mesh(mergedGeometry,[serverBox.material,serverFace.material])
    server.name = 'server';
    server.castShadow = true;
    server.receiveShadow = true;
    server.userData.ejected = false
    return server;
}
export {createServer}